import { inject, Injectable } from '@angular/core';
import { InfoApplicationApiService } from "./info-application-api.service";

@Injectable({
  providedIn: 'root'
})
export class InfoApplicationService {
  private infoApplicationApiService: InfoApplicationApiService = inject(InfoApplicationApiService);

  public getChangelogBack(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.infoApplicationApiService.fetchChangelogBack().subscribe({
        next: (data: string) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getChangelogFront(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.infoApplicationApiService.fetchChangelogFront().subscribe({
        next: (data: string) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
